import { render, staticRenderFns } from "./BannerMeuPrimeiroEmprego.vue?vue&type=template&id=22f5270f&"
import script from "./BannerMeuPrimeiroEmprego.vue?vue&type=script&lang=js&"
export * from "./BannerMeuPrimeiroEmprego.vue?vue&type=script&lang=js&"
import style0 from "./BannerMeuPrimeiroEmprego.vue?vue&type=style&index=0&id=22f5270f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports